/*
 * Copyright (c)  CYBERKOALA LLC 2025.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */

import { useContext } from 'react';
import { CaptionContext } from '@/context/caption-context/caption-context.tsx';

export const useCaptions = () => {
  const context = useContext(CaptionContext);

  if (!context) {
    throw new Error('useCaptions must be used inside CaptionProvider');
  }

  return context;
};
